module.exports = __webpack_public_path__ + "img/Twist41.1772bc1d.jpg";